import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=08c65691"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c65691')) {
      api.createRecord('08c65691', component.options)
    } else {
      api.reload('08c65691', component.options)
    }
    module.hot.accept("./Folders.vue?vue&type=template&id=08c65691", function () {
      api.rerender('08c65691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Folders/Folders.vue"
export default component.exports